const prefix = 'sky';
export enum LocalStorageType {
  LANG = `${prefix}.lang`,
  TOKEN = `${prefix}.token`,
}
